import { allPageTypes } from "global/enums/allPageTypes"
import { useContext, useMemo } from "react"
import { ParentContext } from "../ParentContext"

export const useAllowTicketing = ({ gcProps, allows }) => {

  const pageIcons = null

  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states ?? {}

  // pageContext  
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appTicketing } = aps_global ?? {}
  const { ticketingCaption, allowTicketing, allowTicketingScan } = appTicketing ?? {}

  const _ticketCaption = ticketingCaption ? ticketingCaption : 'Ticketing Manager'
  const _ticketScanCaption = ticketingCaption ? 'Scan ' + ticketingCaption : 'Scan Ticketing'

  let _allowTm;
  let _allowTs;
  let allowTm = !pageIcons && allowTicketing
  let allowTs = !pageIcons && allowTicketingScan
  if (allowTm && allows.atm) { _allowTm = true }
  if (allowTs && allows.ats) { _allowTs = true }

  const allowedItem = (viewItem, segProps, gcProps, hidden) => {
    const { key } = viewItem ?? {}
    return { viewItem, itemKey: key, segProps, gcProps, hidden }
  }

  const items = useMemo(() => {
    const _items = []
    if (_allowTm) { _items.push(allowedItem({ key: allPageTypes.ticketingManager }, { caption: _ticketCaption, icon: 'ticket', cn: 'ao' }, gcProps)) }
    if (_allowTs) { _items.push(allowedItem({ key: allPageTypes.ticketingScan }, { caption: _ticketScanCaption, icon: 'qrcode', cn: 'ao' }, gcProps)) }
    return _items
  }, [_allowTm, _allowTs])

  return items

}